import React from "react";
import { useI18n } from "@/i18n";

const LegalPage = ({ pageKey }) => {
  const { t, dict } = useI18n();
  const page = dict.pages[pageKey];

  return (
    <main className="bg-[#F8FAFC] py-16 lg:py-20" data-testid={`legal-page-${pageKey}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg border border-slate-200 p-6 sm:p-10">
          <h1 className="font-serif text-3xl sm:text-4xl font-bold text-[#0B2545]">{page.title}</h1>
          <p className="mt-2 text-sm text-[#475569]">{page.updated}</p>

          {page.intro && (
            <p className="mt-6 text-base text-[#475569] leading-relaxed">{page.intro}</p>
          )}

          <div className="mt-8 space-y-6">
            {page.sections.map((sec, idx) => (
              <section key={idx}>
                <h2 className="font-serif text-xl font-semibold text-[#0B2545]">{sec.h}</h2>
                <p className="mt-2 text-[#475569] leading-relaxed">{sec.p}</p>
              </section>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default LegalPage;
